<template>
  <div>
    <div id="sub_titleW">{{ titleW }}</div>
    <div id="sub_titleJ">{{ titleJ }}</div>
    <div id="howto_contents">
      <ol>
        <li v-for="item in howtoItems" :key="item.id" :class="item.type">{{ item.message }}</li>
      </ol>
    </div>
  </div>
</template>

<script>
/**
 * 各種ゲームの遊び方
 * 
 * @vue-data {String} [titleW] 世界編タイトル
 * @vue-data {String} [titleJ] 日本編タイトル
 * @vue-data {Array} [howtoItems] 遊び方のli要素用itemの配列
 * @vue-data {Array} [howtoData] 遊び方データオブジェクト
 * @vue-computed {String} currentGame 表示中のView
 */

export default {
  name: "HowToPlay",

  data () {
    return {
      titleW: "",
      titleJ: "",
      howtoItems: [],
      howtoData: [
        {
          game: "worldNormal",
          howto: [
            {
              message: "ジョーカーを抜いた52枚のカードを場に広げる。",
              type: "normal"
            },
            {
              message:
                "ヒントとなる「国の形」「首都」「国旗」「国名」にチェックを入れる。ヒントの数は1～4個まで選べます。",
              type: "normal"
            },
            { message: "「スタート」ボタンをタッチする。", type: "normal" },
            {
              message:
                "左側のヒントから1枚ずつ止まるので正解が分かったタイミングで場に広げたカードを取る。",
              type: "normal"
            },
            {
              message: "「正解を表示」ボタンをタッチして正解のカードを見る。",
              type: "normal"
            },
            { message: "「Next!」ボタンをタッチして次に進む。", type: "normal" }
          ]
        },
        {
          game: "worldHard",
          howto: [
            {
              message: "ジョーカーを抜いた52枚のカードを場に広げる。",
              type: "normal"
            },
            { message: "「スタート」ボタンをタッチする。", type: "normal" },
            {
              message:
                "「お題」の統計情報に当てはまる国のカードを取る。正解のカード数は「1ヵ国」とは限らず、右上に正解国数が表示されます。",
              type: "normal"
            },
            {
              message: "「正解を表示」ボタンをタッチして正解を見る。",
              type: "normal"
            },
            {
              message:
                "「グラフをみてみよう」をタッチすると全52ヵ国中の順位を確認できます。",
              type: "normal"
            },
            {
              message: "「Next!」ボタンをタッチして次に進む。",
              type: "normal"
            },
            {
              message:
                "最初に52枚のカードを全員に配り、「お題」の統計情報に当てはまるカードを捨てて行く「はや抜けゲーム」でも遊べます。",
              type: "tips"
            }
          ]
        },
        {
          game: "japanNormal",
          howto: [
            {
              message: "地方とジョーカーを抜いた47枚のカードを場に広げる。",
              type: "normal"
            },
            {
              message:
                "ヒントとなる「都道府県の形」「都道府県章」「都道府県庁所在地」「都道府県名」にチェックを入れる。ヒントの数は1～4個まで選べます。",
              type: "normal"
            },
            { message: "「スタート」ボタンをタッチする。", type: "normal" },
            {
              message:
                "左側のヒントから1枚ずつ止まるので正解が分かったタイミングで場に広げたカードを取る。",
              type: "normal"
            },
            {
              message: "「正解を表示」ボタンをタッチして正解のカードを見る。",
              type: "normal"
            },
            { message: "「Next!」ボタンをタッチして次に進む。", type: "normal" }
          ]
        },
        {
          game: "japanNormal2",
          howto: [
            {
              message: "地方とジョーカーを抜いた47枚のカードを場に広げる。",
              type: "normal"
            },
            {
              message:
                "ヒントとなる「名所」「名産品」「伝統工芸品」「祭り」にチェックを入れる。ヒントの数は1～4個まで選べます。",
              type: "normal"
            },
            { message: "「スタート」ボタンをタッチする。", type: "normal" },
            {
              message:
                "左側のヒントから1枚ずつ止まるので正解が分かったタイミングで場に広げたカードを取る。",
              type: "normal"
            },
            {
              message: "「正解を表示」ボタンをタッチして正解のカードを見る。",
              type: "normal"
            },
            { message: "「Next!」ボタンをタッチして次に進む。", type: "normal" }
          ]
        },
        {
          game: "japanHard",
          howto: [
            {
              message: "地方とジョーカーを抜いた47枚のカードを場に広げる。",
              type: "normal"
            },
            { message: "「スタート」ボタンをタッチする。", type: "normal" },
            {
              message:
                "「お題」の統計情報に当てはまる都道府県のカードを取る。正解のカード数は「1つの都道府県」とは限らず、右上に正解数が表示されます。",
              type: "normal"
            },
            {
              message: "「正解を表示」ボタンをタッチして正解を見る。",
              type: "normal"
            },
            {
              message:
                "「グラフをみてみよう」をタッチすると全47都道府県中の順位を確認できます。",
              type: "normal"
            },
            {
              message: "「Next!」ボタンをタッチして次に進む。",
              type: "normal"
            },
            {
              message:
                "最初に47枚のカードを全員に配り、「お題」の統計情報に当てはまるカードを捨てて行く「はや抜けゲーム」でも遊べます。",
              type: "tips"
            }
          ]
        },
        {
          game: "Home",
          howto: [
            { message: "トランプを用意", type: "normal" },
            {
              message: "QRコードを読み取ってこのページを開く（タブレット推奨）",
              type: "normal"
            },
            { message: "ゲームを選んで遊ぶ", type: "normal" }
          ]
        },
        {
          game: "World",
          howto: [
            { message: "ゲームを選ぶ", type: "normal" },
            { message: "遊ぶ", type: "normal" }
          ]
        },
        {
          game: "Japan",
          howto: [
            { message: "ゲームを選ぶ", type: "normal" },
            { message: "遊ぶ", type: "normal" }
          ]
        }
      ]
    }
  },

  mounted () {
    this.makeTitle()
    this.setHowtoItem()
  },

  computed: {
    currentGame () {
      return this.$store.getters.currentGame
    }
  },

  watch: {
    currentGame () {
      // console.log("current game is ", this.currentGame)
      this.makeTitle()
      this.setHowtoItem()
    }
  },

  methods: {
    /**
     * 表示中のViewに応じてタイトルを切り替える
     */
    makeTitle () {
      switch (this.currentGame) {
        case "worldNormal":
          this.titleW = "〜世界がわかるルーレット 初級編〜"
          this.titleJ = ""
          break
        case "worldHard":
          this.titleW = "〜世界がわかるルーレット 上級編〜"
          this.titleJ = ""
          break
        case "japanNormal":
          this.titleW = ""
          this.titleJ = "〜日本がわかるルーレット 初級編〜"
          break
        case "japanNormal2":
          this.titleW = ""
          this.titleJ = "〜日本がわかるルーレット 中級編〜"
          break
        case "japanHard":
          this.titleW = ""
          this.titleJ = "〜日本がわかるルーレット 上級編〜"
          break
        default:
          this.titleW = ""
          this.titleJ = ""
          break
      }
    },

    /**
     * 表示中のViewに応じて遊び方データをセットする
     */
    setHowtoItem () {
      this.howtoItems = this.howtoData.find(obj => obj.game === this.currentGame).howto
    }
  }
}
</script>

<style lang="sass" scoped>

  #sub_titleW
    align-self: flex-start
    font-size: 13px
    font-weight: 600
    color: #2E446D

  #sub_titleJ
    align-self: flex-start
    font-size: 13px
    font-weight: 600
    color: #629931

  #howto_contents
    display: flex
    flex-direction: row
    align-items: center
    height: 100%
    ol
      margin: 16px 0
      padding-left: 36px
    li
      line-height: 24px
      text-align: left
      margin-bottom: 8px
      padding-left: 10px
      font-size: 18px
      font-weight: 800

  .normal
    color: #000000
  .tips
    color: #DC5310
    list-style: none
</style>